module.exports = __webpack_public_path__ + "static/media/connect.d3c7c23f.png";